module.exports = __webpack_public_path__ + "static/media/logo-mobile.08487ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/black-friday/logo-mobile.png
// module id = 1490
// module chunks = 0